import { Static, Type } from '@sinclair/typebox';
import { StringEnum } from '../../utils/typebox';

const PresenceShema = StringEnum(['online', 'restricted_online', 'offline', 'away'], {
  description: `The presence of the user.
    - \`online\` if the user is online / available.
    _ \`restricted_online\` if the user is online to a restricted set of contacts.
    - \`offline\` if the user is offline / unavailable.
    - \`away\` if the user is away / busy.`,
});

export type Presence = Static<typeof PresenceShema>;
export const SetPresenceBodySchema = Type.Object({
  presence: PresenceShema,
});

export type SetPresenceBody = Static<typeof SetPresenceBodySchema>;
